import { ProjectsService } from '@core/application/projects.service'
import { ReviewsService } from '@core/application/reviews.service'
import { UsersService } from '@core/application/users.service'
import { InjectionKey } from 'vue'
import type useAuth from './composables/use-auth'
import type useDevToolbox from './composables/use-dev-toolbox'
import { TeamsService } from '@core/application/teams.service'
import { AutoImportService } from '@core/application/autoImportService'
import { Api } from '@evidence/sdk'
import { SafetyInformationSource } from '@core/application/safetyInformation.service'
import { FsnApiClient } from '@infrastructure/fsnApi/fsnApi.client'
import { GuidanceApiClient } from '@infrastructure/guidanceApi/guidanceApi.client'
import { ClinicalTrialsApiClient } from '@infrastructure/clinicalTrialsApi/clinicalTrialsApi.client'

export const ProjectsServiceKey: InjectionKey<ProjectsService> =
  Symbol('ProjectsService')

export const ReviewsServiceKey: InjectionKey<ReviewsService> =
  Symbol('ReviewsService')

export const UsersServiceKey: InjectionKey<UsersService> =
  Symbol('UsersService')

export const AuthKey: InjectionKey<ReturnType<typeof useAuth>> = Symbol('Auth')

export const DevToolboxKey: InjectionKey<ReturnType<typeof useDevToolbox>> =
  Symbol('DevToolbox')

export const TeamsServiceKey: InjectionKey<TeamsService> =
  Symbol('TeamsServiceKey')

export const AutoImportServiceKey: InjectionKey<AutoImportService> = Symbol(
  'AutoImportServiceKey',
)

export const EvidenceServiceApiKey: InjectionKey<Api<any>> = Symbol(
  'EvidenceServiceApiKey',
)
export const ConfigKey: InjectionKey<{
  isConsultant: boolean
}> = Symbol('ConfigKey')

export const SafetyInformationSourcesKey: InjectionKey<
  SafetyInformationSource[]
> = Symbol('SafetyInformationSourcesKey')

export const SafetyInformationApiClientKey: InjectionKey<FsnApiClient> = Symbol(
  'SafetyInformationApiClientKey',
)

export const GuidanceApiClientKey: InjectionKey<GuidanceApiClient> = Symbol(
  'GuidanceApiClientKey',
)

export const ClinicalTrialsApiClientKey: InjectionKey<ClinicalTrialsApiClient> =
  Symbol('ClinicalTrialsApiClientKey')
